import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./sentryInitializer";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
